import { getEligibleSeasonalPromos } from "./helpers/getSeasonalPromos";
import { getSampleTypesInPromo } from "@/utils/va-order-test/sampleTypes";
import { getPromotionsApi } from "@/api/va-order-page/pricing/item/price";
import { parseJson } from "@/utils";

const promotions = {
  namespaced: true,
  state: {
    promotionList: [],
    promotionMap: [],
    seasonalPromotionList: [],
    selectedSeasonalPromoList: [],
    promoCodeThreshold: 600, // promode code not available when discout amount over this threshold before using promo code
    highlightedPromotions: [],
    waiveConciergeFee: false,
    removeWaiveConciergeFeeCount: 0,
    vibrantHighlightList: [],
  },
  mutations: {
    SET_PROMOTION_LIST(state, promotions) {
      state.promotionList = promotions;
    },
    SET_SEASONAL_PROMOTION_LIST(state, seasonalPromotionList) {
      state.seasonalPromotionList = seasonalPromotionList;
    },
    SET_PROMOTION_MAP(state, promotionMap) {
      state.promotionMap = promotionMap;
    },
    SET_HIGHLIGHTED_PROMOTIONS(state, promotionIds) {
      state.highlightedPromotions = promotionIds
    },
    SET_WAIVE_CONCIERGE_FEE(state, bool) {
      state.waiveConciergeFee = bool;
    },
    ADD_REMOVE_WAIVE_CONCIERGE_FEE_COUNT(state) {
      state.removeWaiveConciergeFeeCount++;
    },
    SET_VIBRANT_HIGHLIGHT_LIST(state, vibrantHighlightList) {
      state.vibrantHighlightList = vibrantHighlightList;
    },
  },
  actions: {
    async setPromotionList({ state, commit, dispatch }) {
      let currency = parseJson(localStorage.getItem("currency"));
      let currencyName = currency.name ? currency.name.toLowerCase() : "usd";
      if (state.promotionList.length === 0) {
        let { data } = await getPromotionsApi(currencyName);
        commit("SET_PROMOTION_LIST", data);
        dispatch("setSeasonalPromotionList");
      }
    },

    async setPromotionMap({ commit, dispatch }) {
      // let { data } = await getPromotionMapping();
      let data = [];
      commit("SET_PROMOTION_MAP", data);
      dispatch("setSeasonalPromotionList");

    },

    setHighlightedPromotions({ commit, dispatch }, promotionNames) {
      commit("SET_HIGHLIGHTED_PROMOTIONS", promotionNames);
    },

    setSeasonalPromotionList({ commit, rootGetters, state, rootState, dispatch }) {
      let eligibleSeasonalPromos = 
        getEligibleSeasonalPromos(
          state.promotionList, 
          state.promotionMap, 
          rootState.orderTest.panels.discountPanelList, 
          rootGetters["orderTest/tests/testList"]
        );
      // add sample sets
      if (!eligibleSeasonalPromos) {
        return;
      }
      eligibleSeasonalPromos.forEach(promo => {
        promo.sampleTypeSets = getSampleTypesInPromo(promo, rootGetters["orderTest/tests/testList"]);
      });
      commit("SET_SEASONAL_PROMOTION_LIST", eligibleSeasonalPromos);
    },

    setVibrantHighlightList({ commit }, vibrantHighlightList) {
      commit("SET_VIBRANT_HIGHLIGHT_LIST", vibrantHighlightList);
    },

    setWaiveConciergeFee({ commit }, bool) {
      commit("SET_WAIVE_CONCIERGE_FEE", bool);
    },
  }
};

export default promotions;